import React, { Fragment } from 'react';
import Modal from 'react-modal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { slugify } from '../helpers';
import Header from './Header';
import Hero from './Hero';
import Search from './Search';
import Main from './Main';
import Footer from './Footer';
import Toast from './Toast';
import * as actionCreators from '../actions/actionCreators';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isProductActive: false,
      isIndustryActive: true,
      isInterior: false,
      links: '',
    };

    this.toggleTabs = this.toggleTabs.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    const tmp = this;
    setTimeout(() => {
      window.scrollTo(0, 0);
      tmp.loadData();
    }, 1500);
  }

  // Toggle tabs
  toggleTabs() {
    this.setState({
      isIndustryActive: !this.state.isIndustryActive,
      isProductActive: !this.state.isProductActive,
    });
  }

  loadData() {
    // Give sectors parent name & ID, push sectors to props
    for (let data = this.props.industries, i = 0, l = data.length; i < l; i++) {
      const indus = data[i].id;
      const indusName = data[i].name;
      const squares = [];
      data[i].sectors.forEach(sectors => {
        sectors.parent = indus;
        sectors.parentName = indusName;
        squares.push(sectors.id);
      });
      data[i].squares = squares;
    }

    // Give industries an array of sector IDs for hook
    const sectors = this.props.industries
      .map((indus, i) => indus.sectors)
      .reduce((prev, curr) => prev.concat(curr), []);

    // Add holder for links for search
    const fuzzies = [];

    // Add sectors info
    for (let sects = sectors, i = 0, l = sects.length; i < l; i++) {
      const name = sects[i].name;
      const parent = sects[i].parentName;
      const slug = slugify(name);
      const parSlug = slugify(parent);
      const obj = {};
      obj.label = name;
      obj.value = slug;
      obj.parent = parSlug;
      obj.type = `industries`;
      obj.path = `/${obj.type}/${obj.parent}/`;
      fuzzies.push(obj);
    }

    // Add products info
    for (let prods = this.props.products, i = 0, l = prods.length; i < l; i++) {
      const name = prods[i].name;
      const slug = slugify(name);
      const obj = {};
      obj.label = name;
      obj.value = slug;
      obj.path = `/products/`;
      fuzzies.push(obj);
    }

    // Set for props
    const links = fuzzies.sort((a, b) => {
      const initial = a.label.toLowerCase();

      const next = b.label.toLowerCase();
      if (initial < next) return -1;
      if (initial > next) return 1;
      return 0;
    });

    // Update our link data
    this.setState({
      links,
    });
  }

  render() {
    const { links, isInterior, isProductActive, isIndustryActive } = this.state || {};
    const {
      toggleGuide,
      isGuideOpen,
      modalIsOpen,
      closeModal,
      bookmarkPage,
      isFilterOpen,
      history,
      industries,
      products,
      showInstallBanner,
      toast
    } = this.props;
    return (
      <Fragment>
        <Header
          toggleGuide={toggleGuide}
          isGuideOpen={isGuideOpen}
          modalIsOpen={modalIsOpen}
          guide="User Guide"
          closeModal={closeModal}
          bookmarkPage={bookmarkPage}
        />
        <Hero
          history={history}
          heading="Commercial Insurance"
          subhead="Mid-Market Web App"
          isInterior={isInterior}
        />
        <Search history={history} links={links} />
        <Main
          industries={industries}
          products={products}
          toggleTabs={this.toggleTabs}
          isProductActive={isProductActive}
          isIndustryActive={isIndustryActive}
          isGuideOpen={isGuideOpen}
          isFilterOpen={isFilterOpen}
          handleMobileFilter={this.handleMobileFilter}
        />

        <Footer feedback="Feedback" />
        {showInstallBanner && <Toast toast={toast} />}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  industries: state.industries,
  products: state.products,
  appetites: state.appetites,
  resources: state.resources,
  contacts: state.contacts,
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

const AppWrap = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default AppWrap;



// WEBPACK FOOTER //
// ./src/components/App.js